export const shirts = [

    {
        id: "2366",
        nome: 'Fragment Design',
        preco: 950,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_800,h_800,ar_1:1/v1748550340/2363c8c3-fd48-4c73-bdf9-cb867ba85bd4.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748551167/Slice_14_ql8hjw.png',
        ],
        marca: 'Cactus Jack & Kaws',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "9827",
        nome: 'Travis Scott Utopia I',
        preco: 890,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748550749/8a9e89d4-16ed-47b9-9f0b-530dc2956266.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748551166/Slice_13_lmzpbs.png',
        ],
        marca: 'Cactus Jack',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "4246",
        nome: 'Rain Frame',
        preco: 335,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_1900,h_1900,ar_1:1/v1748524215/812c3a0d-91ce-4db7-9d89-284b06ec4f37.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545537/Slice_2_dwr5dj.png'
        ],
        marca: 'Stüssy',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "8923",
        nome: 'International Tribe',
        preco: 335,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_1900,h_1900,ar_1:1/v1748525321/2037fa5b-4b47-4e3e-94a0-cc127846cf47.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545538/Slice_11_rs2g4t.png'
        ],
        marca: 'Stüssy',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "3143",
        nome: '8 Ball',
        preco: 750,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1747343344/a51dc811-a37d-444d-b202-99e457dac7fc.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545533/Slice_2_ykpsfy.png'
        ],
        marca: 'Stüssy & Born x Raised',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "7447",
        nome: 'Stop Making Sense',
        preco: 235,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_1010,h_1010,ar_1:1/e_background_removal/b_rgb:FFFFFF/f_png/v1747343183/s-l1200_n7fbsz.jpg',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545533/Slice_5_xmb5lc.png'
        ],
        marca: 'Stüssy & Talking Heads',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "3985",
        nome: 'Presenté',
        preco: 199,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902808/camiseta-1_ibubsg.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545546/Slice_10_vp5kte.png',
        ],
        marca: 'Barra',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "1777",
        nome: 'Berço B',
        preco: 199,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902808/camiseta-3_tp4ows.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748473072/camiseta-13_siwwoo.png'
        ],
        marca: 'Barra',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "2075",
        nome: 'B Garça',
        preco: 199,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902809/camiseta-4_smdk2x.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/e_background_removal/b_rgb:FFFFFF/f_png/v1748470490/7f17dfe0-b3d1-4b05-addf-2ba28eacafba.png'
        ],
        marca: 'Barra',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "1330",
        nome: 'Assinatura',
        preco: 199,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902814/camiseta-2_gpgcpn.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748473068/camiseta-10_taqbze.png'
        ],
        marca: 'Barra',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "1805",
        nome: 'B Tribal Solar',
        preco: 189,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902809/camiseta-5_t8bynf.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545532/Slice_3_aulbdk.png'
        ],
        marca: 'Barra',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "2936",
        nome: 'Ahlma Tribal',
        preco: 189,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902809/camiseta-6_cnuxsd.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545532/Slice_4_dau7dl.png',
        ],
        marca: 'Barra',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "8731",
        nome: 'Pale Horse',
        preco: 249,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1747342685/182cbb79-1933-465d-8ae2-8e23744e2ccd.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545540/Slice_1_ave6u4.png',
        ],
        marca: 'Deathwish',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "2423",
        nome: 'Monster Dog',
        preco: 342,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload//c_crop,w_805,h_805,ar_1:1//e_background_removal/b_rgb:FFFFFF/f_png/v1748541611/4b5d978c-6bac-40ba-9674-3715fae29128.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545540/Slice_9_vl6dau.png'
        ],
        marca: 'Piet & Oakley',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "7634",
        nome: 'Enlightenment',
        preco: 235,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_905,h_905,ar_1:1/v1748551658/284b2c72-478d-4030-8a0a-06a624e38e69.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748551673/Slice_16_mhbdbu.png',
        ],
        marca: 'Hellstar',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "2484",
        nome: 'Lagoa Preta',
        preco: 219,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902809/camiseta-7_gebp8a.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748562340/Slice_47_cz7owl.png',
        ],
        marca: 'Mad Enlatados',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "4550",
        nome: 'Pé de Feijão',
        preco: 219,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902809/camiseta-8_qxnzen.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_590,h_590,ar_1:1/v1748520501/4efbcd9d-a862-4809-a37c-2f0fdc8e9459.png'
        ],
        marca: 'Mad Enlatados',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "3191",
        nome: 'RPG',
        preco: 219,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746918196/7096c0b9-50da-45b5-80c1-1ef47ba46ef3.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1//v1748472095/d7f5ae04-9835-4a83-8bc3-cab52d62e715.png'
        ],
        marca: 'Mad Enlatados',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "4767",
        nome: 'Comet',
        preco: 189,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_940,h_940,ar_1:1/v1746920098/bde05e9d-a3a6-477e-a5c5-c66fdc6203ea.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748473082/camiseta-6_r78ytm.png',
        ],
        marca: 'High',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "1799",
        nome: 'Razor',
        preco: 189,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_1160,h_1160,ar_1:1/v1746902810/camiseta-11_uoy9xn.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748473190/85c227af-f3ec-4f96-844e-a7126052d0d8.png'
        ],
        marca: 'High',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "1269",
        nome: 'Cellphone',
        preco: 189,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902810/camiseta-12_xcnfci.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748473077/camiseta-3_stnwm9.png'
        ],
        marca: 'High',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "1133",
        nome: 'Golf',
        preco: 189,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902810/camiseta-13_a7xr15.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748473079/camiseta-4_ld8som.png'
        ],
        marca: 'High',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "6919",
        nome: 'Think',
        preco: 189,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902816/camiseta-10_qjmczx.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748473073/camiseta-1_yvkkgl.png'
        ],
        marca: 'High',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "3623",
        nome: 'X-HIGH',
        preco: 149,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746902812/camiseta-15_bvvsrh.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748473328/646db360-cf90-4961-bbd8-f8b150529282.png'
        ],
        marca: 'High',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "9872",
        nome: 'Brazil Yellow',
        preco: 435,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_1100,h_1100,ar_1:1/v1748551515/f6b1b457-789d-4228-a063-e5bc11c6d645.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748551598/Slice_15_gxzfv8.png',
        ],
        marca: 'Corteiz',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "4133",
        nome: 'F*CK MONEY',
        preco: 520,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746919188/715de7af-4d0e-4574-8621-ba4369bea4ce.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545538/Slice_7_sescpr.png',
        ],
        marca: 'Supreme',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
    {
        id: "4399",
        nome: 'RTG',
        preco: 570,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746919383/dfd0e9f0-0801-49e8-bbaf-c2c5846a5b86.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748545534/Slice_6_abvo71.png'
        ],
        marca: 'Supreme & The North Face',
        modelo: 'Camiseta',
        route: 'camiseta',
    },
]

export const moletons = [

    {
        id: "8723",
        nome: 'FCB Spray Logo ',
        preco: 799,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748182906/8ab0fc27-4a5b-4a97-bc58-66b933d65a38.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748553582/Slice_17_s9jgug.png',
        ],
        marca: 'Nike & Cactus Jack',
        modelo: 'Moletom',
        route: 'moletom',
    },
    {
        id: "3622",
        nome: 'Logo Inverso',
        preco: 449,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748189794/moletom-2_dfdkan.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748553447/6092b32b-85a6-45b1-9984-1d8c2b353f58.png'
        ],
        marca: 'Class',
        modelo: 'Moletom',
        route: 'moletom',
    },
    {
        id: "2542",
        nome: 'Trap 93',
        preco: 3189,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_800,h_800,ar_1:1/v1748552441/d80c1ef9-0eeb-43ce-93e5-329f9646cf85.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748554797/Slice_22_nkmfuu.png'
        ],
        marca: 'Bape',
        modelo: 'Jaqueta',
        route: 'moletom',
    },
    {
        id: "2222",
        nome: 'P*NK v2',
        preco: 2499,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_730,h_730,ar_1:1/v1748553794/b82acebd-1a8d-4bb2-8a72-82a94f60084e.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748553878/Slice_18_jz8xue.png'
        ],
        marca: 'Sp5der',
        modelo: 'Moletom',
        route: 'moletom',
    },
    {
        id: "5555",
        nome: 'OG Web 555',
        preco: 2569,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_750,h_750,ar_1:1/v1748190377/f1c6df66-4f11-4448-baa7-cf70af3f7a04.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748554677/Slice_20_xpbwe0.png'
        ],
        marca: 'Sp5der',
        modelo: 'Moletom',
        route: 'moletom',
    },
    {
        id: "6666",
        nome: 'OG Web',
        preco: 1499,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_1390,h_1390,ar_1:1/v1748190383/8c1faa40-78d4-4328-9207-d84784b707d3.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748554213/Slice_19_jnr9an.png'
        ],
        marca: 'Sp5der',
        modelo: 'Moletom',
        route: 'moletom',
    },
    {
        id: "1913",
        nome: 'Staple',
        preco: 1299,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748188514/efa1d453-c501-47de-8a31-b7f4471e0b67.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748554678/Slice_21_muh012.png'
        ],
        marca: 'Vlone & Fragment',
        modelo: 'Moletom',
        route: 'moletom',
    },
]

export const shorts = [
    {
        id: "6725",
        nome: 'College Relaxed Fit 13 Oz Denim Shorts',
        preco: 573,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748184890/9322d66a-245c-4803-a467-e3e2b3d8df18.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748557159/75996014-deac-40c3-b3fd-db47a60354b4.png'
        ],
        marca: 'Bape',
        modelo: 'Jorts',
        route: 'shorts',
    },
    {
        id: "1239",
        nome: '4SUF Jeans',
        preco: 399,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_550,h_550/e_background_removal/b_rgb:FFFFFF/f_png/v1748183946/24553cea-fb79-402d-9eb1-95f1f6327b42.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_550,h_550,ar_1:1/e_background_removal/b_rgb:FFFFFF/f_png/v1748557239/96d96a7c-5f3c-4ad4-bec3-39f2d97bc5da.png'
        ],
        marca: 'Sufgang',
        modelo: 'Jorts',
        route: 'shorts',
    },
    {
        id: "5678",
        nome: 'Cirvalínea Double Hand Marrom',
        preco: 569,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748183143/jorts_jeans_mad_enlatados_cirvalinea_double_hand_marrom_8639_3_0e72945125c5bf36f954f02ae8e2fd59_dtotrs.webp',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748557429/ad5bc993-b039-4373-914d-ff3ac0da7bb6.png'
        ],
        marca: 'Mad Enlatados',
        modelo: 'Jorts',
        route: 'shorts',
    },
    {
        id: "7315",
        nome: 'Cirvalínea Double Hand Vermelho',
        preco: 569,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748183135/jorts_jeans_mad_enlatados_cirvalinea_double_hand_vermelho_8641_1_7d75162daacc9ca1f4853e48fa46dafb_l6wnxu.webp',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748557545/5e1e879a-eb42-4c3a-8134-00406ba50cc8.png'
        ],
        marca: 'Mad Enlatados',
        modelo: 'Jorts',
        route: 'shorts',
    },
    {
        id: "5123",
        nome: 'Cinto Tribal',
        preco: 534,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748185305/da818323-9ec3-44fb-9c3a-d8064074d6e7.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748557642/jorts_jeans_mad_enlatados_cinto_tribal_8637_3_9ad5df2fba77045115266a18c0ed3a33_rmmcrx.webp'
        ],
        marca: 'Mad Enlatados',
        modelo: 'Jorts',
        route: 'shorts',
    },
    {
        id: "1245",
        nome: 'C-Star Denim',
        preco: 984,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_790,h_790/v1748184153/f5183adf-1e03-4c4f-b47b-74230f2dc3ea.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_800,h_800/v1748557677/f9f10034-6a0e-44c4-ae57-99d838320bb9.png'
        ],
        marca: 'Corteiz',
        modelo: 'Jorts',
        route: 'shorts',
    },
    {
        id: "8713",
        nome: 'Alcatraz Denim Washed Black',
        preco: 484,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748187029/d85941e7-648b-4d2c-a2a6-04ad7129353c.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748557817/1ea367b9-235a-4c1d-93c8-7da135ebee6a.png'
        ],
        marca: 'Corteiz',
        modelo: 'Jorts',
        route: 'shorts',
    },
    {
        id: "6324",
        nome: 'Highstar Blue',
        preco: 384,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748183225/0d684295-6116-42dc-b4a3-b5966a926fb5.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748557882/19095256-3910-429f-8256-a6c1a59b2e3b.png'
        ],
        marca: 'High',
        modelo: 'Jorts',
        route: 'shorts',
    },
    {
        id: "2848",
        nome: 'FCB Skeleton Home',
        preco: 333,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748182753/cd855204-90a9-43db-b14b-57d8e50b6baa.png',
        ],
        marca: 'Nike & Cactus Jack',
        modelo: 'Bermuda',
        route: 'shorts',
    },
];

export const gorros = [
    {
        id: "4024",
        nome: '',
        preco: 89,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905514/touca_sometimes_online_pypait.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748555935/Slice_27_fywf7t.png'
        ],
        marca: 'Sometimes Online',
        modelo: 'Gorro',
        route: 'acessorios',
    },
    {
        id: "2487",
        nome: 'Goods Logo Classic',
        preco: 96,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905517/touca_barra_goods_logo_classic_t5drxc.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748555933/Slice_25_qbzdw8.png'
        ],
        marca: 'Barra',
        modelo: 'Gorro',
        route: 'acessorios',
    },
    {
        id: "4161",
        nome: 'Baska',
        preco: 89,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905513/touca_ous_baska_do1drj.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748555932/Slice_23_w2hhbn.png'
        ],
        marca: 'Öus',
        modelo: 'Gorro',
        route: 'acessorios',
    },
    {
        id: "1979",
        nome: 'Outlined',
        preco: 99,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905516/touca_thrasher_outlined_vxbodr.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748555933/Slice_26_nkobma.png'
        ],
        marca: 'Thrasher',
        modelo: 'Gorro',
        route: 'acessorios',
    },
    {
        id: "1417",
        nome: 'Goovy',
        preco: 159,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905512/touca_high_goovy_cupup2.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748555932/Slice_24_ptavix.png'
        ],
        marca: 'High',
        modelo: 'Gorro',
        route: 'acessorios',
    },
];

export const bones = [
    {
        id: "3703",
        nome: 'Camo',
        preco: 239,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905395/bone_barra_camo_rysg4b.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/c_crop,w_830,h_830,ar_1:1/v1748556194/effa760b-f80d-440c-bf34-e4e1904bfc66.png'
        ],
        marca: 'Barra',
        modelo: 'Boné',
        route: 'acessorios',
    },
    {
        id: "2288",
        nome: 'Logo Areia',
        preco: 139,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905396/bone_barra_logo_areia_u7pybc.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_830,h_830,ar_1:1/v1748556437/bb1cbf97-5b92-497d-a714-672b89e274a7.png'
        ],
        marca: 'Barra',
        modelo: 'Boné',
        route: 'acessorios',
    },
    {
        id: "3530",
        nome: 'Veludo',
        preco: 142,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905393/bone_tupode_veludo_vaclvc.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748556602/Slice_31_jkcuh3.png'
        ],
        marca: 'Tupode',
        modelo: 'Boné',
        route: 'acessorios',
    },
    {
        id: "4530",
        nome: 'Doggy Style®',
        preco: 159,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905391/bone_bolovo_doggy_style_eb36y6.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748556603/Slice_29_miumad.png'
        ],
        marca: 'Bolovo',
        modelo: 'Boné',
        route: 'acessorios',
    },
    {
        id: "4645",
        nome: 'Fire Dad Hat',
        preco: 142,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905392/bone_carnan_dad_hat_oc9bjq.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/e_background_removal/b_rgb:FFFFFF/f_png/v1748556603/Slice_30_nm20z7.png'
        ],
        marca: 'Carnan',
        modelo: 'Boné',
        route: 'acessorios',
    },
    {
        id: "3196",
        nome: 'Utility Dad Hat',
        preco: 169,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905391/bone_baw_utility_sgorsk.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/e_background_removal/b_rgb:FFFFFF/f_png/v1748556610/Slice_28_zhozyd.png'
        ],
        marca: 'Baw',
        modelo: 'Boné',
        route: 'acessorios',
    },
    {
        id: "2631",
        nome: 'Flame',
        preco: 995,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746912863/yeezy_gap_flame_yzd5ox.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748556793/Slice_32_r8ylj6.png'
        ],
        marca: 'Yeezy & Gap',
        modelo: 'Boné',
        route: 'acessorios',
    },
]

export const sneakers = [
    {
        id: "4546",
        nome: 'Halloween Symbiote',
        preco: 461,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746910496/nike_dunk_halloween_k0e1tv.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/e_background_removal/b_rgb:FFFFFF/f_png/v1748559187/704cb073-3fd4-4b59-a5b6-96b31f96db92.png'
        ],
        marca: 'Nike',
        modelo: 'Dunk Low GS',
        route: 'sneakers',
    },
    {
        id: "5699",
        nome: 'Black Pigeon',
        preco: 461,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746911149/nike_dunk_black_pigeon_akcj1x.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_790,h_790,ar_1:1/v1748559260/c4644871-f693-4125-ad2e-49e753d6dfa0.png'
        ],
        marca: 'Nike',
        modelo: 'Dunk Low SB',
        route: 'sneakers',
    },
    {
        id: "2767",
        nome: 'LX White',
        preco: 461,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746910810/nike_blazer_lx_white_qzplhd.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748559721/Slice_33_ln7yt7.png'
        ],
        marca: 'Nike',
        modelo: 'Blazer Mid 77',
        route: 'sneakers',
    },
    {
        id: "4287",
        nome: '',
        preco: 629,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746911786/ous_fluente_gtx_r3lgmm.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748560740/Slice_34_fnjiiy.png'
        ],
        marca: 'Öus',
        modelo: 'Fluente GTX',
        route: 'sneakers',
    },
    {
        id: "4596",
        nome: '',
        preco: 410,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905734/sousa_ny_knicks_qzd8my.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/v1748558573/a97572b1-7946-442a-b913-36d56c107b17.png'
        ],
        marca: 'Söusa',
        modelo: 'NBA NY Knicks',
        route: 'sneakers',
    },

    {
        id: "3893",
        nome: '',
        preco: 348,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746912375/tesla_hertz_blackart_fhcu7q.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/e_background_removal/b_rgb:FFFFFF/c_crop,w_945,h_945,ar_1:1,f_png/v1748559977/a349bc3b-f453-438d-89cb-05e61423e719.png'
        ],
        marca: 'Tesla',
        modelo: 'Hertz Black Art',
        route: 'sneakers',
    },
    {
        id: "1698",
        nome: '',
        preco: 599,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905740/dc_construct_imp_hgmdnx.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_400,h_400,ar_1:1/v1748559480/b2108d2c-4b23-45bd-8bec-83ae84b76b85.png'
        ],
        marca: 'DC Shoes',
        modelo: 'Construct IMP',
        route: 'sneakers',
    },
    {
        id: "4164",
        nome: '',
        preco: 350,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905745/dc_kalynx_zero_imp_gdwxti.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_900,h_900,ar_1:1/v1748558623/687c159e-9239-44ef-9171-49e9853aef88.png'
        ],
        marca: 'DC Shoes',
        modelo: 'Kalynx Zero IMP',
        route: 'sneakers',
    },
    {
        id: "1988",
        nome: '',
        preco: 529,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905706/dc_thrasher_truth_camo_n3ucah.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_890,h_890,ar_1:1/v1748559774/4a40775d-c876-4d11-a872-c9161b72daaa.png'
        ],
        marca: 'DC Shoes & Thrasher',
        modelo: 'Black Camo Truth',
        route: 'sneakers',
    },

    {
        id: "1737",
        nome: 'Chorão',
        preco: 348,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746912343/qix_chorao_lado_b_camo_g2pjad.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748560528/c9633967-dfe8-4d94-9884-95d0b0b2d266.png'
        ],
        marca: 'Qix',
        modelo: 'Lado B Camo',
        route: 'sneakers',
    },
    {
        id: "3247",
        nome: 'Bad Bunny Back to School',
        preco: 489,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_670,h_670,ar_1:1/v1748560221/75e7b56b-d587-4fd6-b8d7-264611630590.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_600,h_600,ar_1:1/v1748560282/bdf8d97c-5304-493f-99cd-fe226d643813.png'
        ],
        marca: 'Adidas',
        modelo: 'Forum Low',
        route: 'sneakers',
    },
    {
        id: "1228",
        nome: '',
        preco: 679,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746905723/rebook_baw_club_c_mwzynl.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,w_750,h_750,ar_1:1/v1748558762/f5b93411-868a-4420-9fc5-7c9b326bc8a2.png'
        ],
        marca: 'Rebook & Baw',
        modelo: 'Club C Revenge',
        route: 'sneakers',
    },
];

export const shapes = [
    {
        id: "4496",
        nome: 'Roadster',
        preco: 283,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906559/primitive_roadster_xs0vmw.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748561599/Slice_42_pcywtk.png'
        ],
        marca: 'Primitive',
        modelo: 'Shape',
        route: 'skateboard',
    },
    {
        id: "1545",
        nome: 'Bob Marley Forever Team',
        preco: 283,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906557/primitive_bob_forever_team_vc9hbt.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748561595/Slice_41_ndzdkw.png'
        ],
        marca: 'Primitive',
        modelo: 'Shape',
        route: 'skateboard',
    },
    {
        id: "4112",
        nome: 'This Way',
        preco: 271,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906541/deathwish_this_way_jzjwou.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748561580/Slice_36_mq5ksj.png'
        ],
        marca: 'Deathwish',
        modelo: 'Shape',
        route: 'skateboard',
    },
    {
        id: "1187",
        nome: 'Inferno Offering',
        preco: 298,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906566/deathwish_inferno_xlq5vg.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748561578/Slice_35_z7gjtx.png'
        ],
        marca: 'Creature',
        modelo: 'Shape',
        route: 'skateboard',
    },
    {
        id: "2206",
        nome: 'AP OG Logo',
        preco: 275,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906562/april_logo_fuyhnh.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748561586/Slice_38_znilhv.png'
        ],
        marca: 'April',
        modelo: 'Shape',
        route: 'skateboard',
    },
    {
        id: "3505",
        nome: 'Rodrigues Jeanne',
        preco: 275,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906555/hockey_jeanne_jt1hus.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748561589/Slice_39_bsmffw.png'
        ],
        marca: 'Hockey',
        modelo: 'Shape',
        route: 'skateboard',
    },
    {
        id: "4327",
        nome: 'Predictions',
        preco: 289,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906544/fucking_awesome_predictions_wnllqv.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748561593/Slice_40_hoekdb.png'
        ],
        marca: 'Fucking Awesome',
        modelo: 'Shape',
        route: 'skateboard',
    },
    {
        id: "2496",
        nome: 'Catacomb',
        preco: 242,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906564/creature_catacomb_uwlsrh.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748561584/Slice_37_umnkwr.png'
        ],
        marca: 'Creature',
        modelo: 'Shape',
        route: 'skateboard',
    },
]

export const lixas = [
    {
        id: "4556",
        nome: 'Ultragrip',
        preco: 89,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906393/jessup_ultragrip_vozged.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748562027/Slice_46_ikpj67.png'
        ],
        marca: 'Jessup',
        modelo: 'Lixa',
        route: 'skateboard',
    },
    {
        id: "4334",
        nome: 'OG Spray',
        preco: 189,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906396/shake_junt_spray_zemjsx.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748562019/Slice_45_hwjind.png'
        ],
        marca: 'Shake Junt',
        modelo: 'Lixa',
        route: 'skateboard',
    },
    {
        id: "4168",
        nome: 'Stamp Print',
        preco: 179,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906391/grizzly_stamp_print_rulgni.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748562024/Slice_44_dovce6.png'
        ],
        marca: 'Grizzly',
        modelo: 'Lixa',
        route: 'skateboard',
    },
    {
        id: "4061",
        nome: 'Bighead Inferno',
        preco: 199,
        imagens: [
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1746906390/spitfire_bighead_inferno_p6tdix.png',
            'https://res.cloudinary.com/dsmx8c5ug/image/upload/c_crop,ar_1:1/v1748562021/Slice_43_nqsuro.png'
        ],
        marca: 'Spitfire',
        modelo: 'Lixa',
        route: 'skateboard',
    },
];

export const vestuario = [
    ...moletons,
    ...shirts,
]
export const accessories = [
    ...gorros,
    ...bones,
];

export const skateItens = [
    ...shapes,
    ...lixas,
]

export const vetCatalogo = [
    ...vestuario,
    ...accessories,
    ...sneakers,
    ...skateItens,
    ...shorts,
];
